import { useEffect } from "react";
import { Outlet } from "react-router-dom";

import { Toaster } from "@/client/components/ui/sonner";
import { useAuthStore } from "@/client/features/auth/auth-store";

/**
 * Top-level layout for every route: kicks off the one-time session check and
 * hosts the toast outlet. Renders the matched route via <Outlet />.
 */
export function RootLayout() {
  const loadSession = useAuthStore((s) => s.loadSession);

  useEffect(() => {
    void loadSession();
  }, [loadSession]);

  return (
    <>
      <Outlet />
      <Toaster position="top-right" richColors />
    </>
  );
}
